

// Modal Size Guide

(function () {
  function openModal(modal, opener) {
    if (!modal) return;

    modal.setAttribute('open', '');
    modal.setAttribute('aria-hidden', 'false');
    modal._openedBy = opener;
    document.body.classList.add('overflow-hidden');

    var dialog = modal.querySelector('[role="dialog"]');
    if (dialog) {
      dialog.focus();
    }
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.removeAttribute('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    if (modal._openedBy) {
      modal._openedBy.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-action="open-modal"]');
    if (openButton) {
      event.preventDefault();
      openModal(document.getElementById(openButton.getAttribute('aria-controls')), openButton);
      return;
    }

    var closeButton = event.target.closest('[data-action="close-modal"]');
    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest('.background-modal-custom'));
      return;
    }

    var modal = event.target.closest('.background-modal-custom[open]');
    if (modal && event.target === modal) {
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeModal(document.querySelector('.background-modal-custom[open]'));
  });
})();
